import { render, staticRenderFns } from "./badgemenu.vue?vue&type=template&id=849e1bf8&"
import script from "./badgemenu.vue?vue&type=script&lang=js&"
export * from "./badgemenu.vue?vue&type=script&lang=js&"
import style0 from "./badgemenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports